// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { change } from 'redux-form'
import getNestedByString from 'helpers/getNestedByString'

// takes the form's name and the selected column.
// if it was the same column as selected before, then it toggles asc,
// otherwise it sets the new column and sets asc to true.

const handleSort = (formName, col) => (dispatch, getState) => {
  const { form } = getState()

  const {
    tableSort: oldSort,
  } = getNestedByString(form, formName).values

  // default to saying there is no sort.
  let tableSort = null

  // if we've selected the same column and we're currently ascending,
  // then set it to descending.
  if (oldSort?.col === col && oldSort.asc) {
    tableSort = {
      col,
      asc: false,
    }

  // else if we've selected a new column, then set that column
  // and order by ascending.
  } else if (oldSort?.col !== col) {
    tableSort = {
      col,
      asc: true,
    }
  }

  // this means that if the user clicks on a column that's currently sorting by
  // asc === false, then we will turn off the sort (by returning null).
  // This mimics the sorting behavior of Kendo Grid.

  return dispatch(change(formName, 'tableSort', tableSort))
}

export default handleSort
